// export const BASE_URL = 'http://store-staging.classplus.co/';
// export const BASE_URL = 'https://wl-apip.classplusapp.co/';
const baseUrl_devTesting = "http://store-gcp-sarthak.classplus.co/"
const baseUrl_prod = 'https://api.classplusapp.com/';
export const BASE_URL = baseUrl_prod
export const IMAGE_BASE_URL =
  'https://d2sqt6igbl7quy.cloudfront.net/classplus-websites/common/images/';

export default baseUrl_prod;
